
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import BookingDialog from '@/components/BookingDialog.vue';

  @Component({
    components: {
      BookingDialog
    }
  })
  export default class CalOverviewView extends Vue {
      public focus = '';
      public type = 'month';
      public types: any[] = [{ state: 'Monat', abbr: 'month'}, { state: 'Woche', abbr: 'week'}, { state: 'Tag', abbr: 'day'},]; 
      public mode = 'stack';
      public weekday: number[] = [1, 2, 3, 4, 5, 6, 0];
      public value = '';
      public events: any = [];
      public newEvent: any = null;

      public showDialog = false;
      
      private dragEvent: any;
      private dragTime: any;
      private extendOriginal: any;
      private createEvent: any;
      private createStart: any;
      private updateEvent = false;

      private space = "";
      private token = "";

      private today = new Date();


      public async mounted() {
        this.space = this.$route.query.space as string;
        this.token = this.$route.query.token as string;

        this.loadEvents();
      }
      
      public async loadEvents() {
        let response = null;

        const fromTime = this.getFirstDayOfMonth(this.today.getFullYear(), this.today.getMonth() ).getTime();
        const toTime = this.today.getMonth() < 12 ? this.getFirstDayOfMonth(this.today.getFullYear(), this.today.getMonth()+1 ).getTime() : this.getFirstDayOfMonth(this.today.getFullYear()+1, 1 ).getTime();

        if( this.space ){
          if( process.env.NODE_ENV === 'development' ) {
            response = await fetch(`http://localhost:7071/api/getEventsForStudio?space=${this.space}&token=${this.token}&fromTime=${ fromTime }&toTime=${ toTime }`).then(res => res.json());
          } else {
            response = await fetch(`/api/getEventsForStudio?space=${this.space}&token=${this.token}&fromTime=${ fromTime }&toTime=${ toTime }`).then(res => res.json());
          }
        } else {
          window.setTimeout( this.refreshEvents, 200 );
        }

        if( response != null && response.success == true )
          this.events = response.bookings;
      }

      public viewDay( ev: any): void {
        this.focus = ev.date;
        this.type = 'day';
      }

      public showEvent( ev: any): void {
        this.newEvent = ev.event
        this.showDialog = true;
        this.updateEvent = true;
      }

      public closeDialog(): void {
        this.showDialog = false;
        this.loadEvents();
      }

      /** Drag Start */
      public startDrag ( event:any , timed:any ) {
        if (event && timed) {
          this.dragEvent = event
          this.dragTime = null
          this.extendOriginal = null
        }
      } 

      public startTime (tms: any ) {
        const mouse = this.toTime(tms)

        if (this.dragEvent && this.dragTime === null) {
          const start = this.dragEvent.start

          this.dragTime = mouse - start
        } else {
          this.createStart = this.roundTime(mouse)
          this.createEvent = {
            name: `Neue Buchung`,
            color: '#2196F3',
            start: this.createStart,
            end: this.createStart,
            timed: true,
          }

          this.events.push(this.createEvent)
        }
      }


      public extendBottom (event: any) {
        this.createEvent = event
        this.createStart = event.start
        this.extendOriginal = event.end
      }

      public mouseMove (tms:any) {
        const mouse = this.toTime(tms)

        if (this.dragEvent && this.dragTime !== null) {
          const start = this.dragEvent.start
          const end = this.dragEvent.end
          const duration = end - start
          const newStartTime = mouse - this.dragTime
          const newStart = this.roundTime(newStartTime)
          const newEnd = newStart + duration

          this.dragEvent.start = newStart
          this.dragEvent.end = newEnd
        } else if (this.createEvent && this.createStart !== null) {
          const mouseRounded = this.roundTime(mouse, false)
          const min = Math.min(mouseRounded, this.createStart)
          const max = Math.max(mouseRounded, this.createStart)

          this.createEvent.start = min
          this.createEvent.end = max
        }
      }

      public endDrag () {

        if( this.newEvent != null && !this.updateEvent ){
          
          const i = this.events.indexOf(this.newEvent)
            if (i !== -1) {
              this.events.splice(i, 1)
            }
        } else {
          this.updateEvent = false;
        }
        // createEvent has start and end as parameters
        console.log( this.createEvent);

        this.showDialog = true;
        this.newEvent = this.createEvent;

        this.dragTime = null
        this.dragEvent = null
        this.createEvent = null
        this.createStart = null
        this.extendOriginal = null
      }

      public cancelDrag () {
        if (this.createEvent) {
          if (this.extendOriginal) {
            this.createEvent.end = this.extendOriginal
          } else {
            const i = this.events.indexOf(this.createEvent)
            if (i !== -1) {
              this.events.splice(i, 1)
            }
          }
        }

        this.createEvent = null
        this.createStart = null
        this.dragTime = null
        this.dragEvent = null
      }

      public async refreshEvents(e:any) {
        let aDayInMs = 24 * 60 * 60 * 1000;

        if( this.space ){
          if( process.env.NODE_ENV === 'development' ) {
            this.events = ( await fetch(`http://localhost:7071/api/getEventsForStudio?space=${ this.space }&token=${this.token}&fromTime=${ new Date( e.start.date ).getTime() }&toTime=${ new Date( e.end.date ).getTime() + aDayInMs }`).then(res => res.json()) ).bookings;
          } else {
            this.events = ( await fetch(`/api/getEventsForStudio?space=${ this.space }&token=${this.token}&fromTime=${ new Date( e.start.date ).getTime() }&toTime=${ new Date( e.end.date ).getTime() + aDayInMs }`).then(res => res.json()) ).bookings;
          }
        } else {
          window.setTimeout( this.refreshEvents, 200 );
        }

    }

      /** Helper  */
      private roundTime (time: any , down = true) {
        const roundTo = 15 // minutes
        const roundDownTime = roundTo * 60 * 1000

        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      }

      private toTime (tms:any) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      }

      private getFirstDayOfMonth (year: number, month: number) {
        return new Date(year, month, 1);
    }

  }
